/**
 * @module
 * @format
 */

import {service, reactive} from 'nova';
import {make, UserProfileImageApi} from './api.js';

@service
class UserImageWaiting {
  // DEBUG = true;
  @reactive accessor image = '';
  @reactive accessor inactive = true;
  @reactive accessor active = false;

  /**
   * @returns {Promise<void>}
   */
  async sync() {
    const api = make(UserProfileImageApi);
    const waitingImage = await api.get();

    this.image = waitingImage ? waitingImage.url : '';
    this.inactive = !waitingImage;
    this.active = !!waitingImage;
  }
}

export {UserImageWaiting};
